export default __webpack_public_path__ + "static/media/pagetitle-bg.65252501.jpg";